/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { CardLooksLike } from './CardLooksLike';
export type CarCard = {
    readonly id: number;
    /**
     * `true` if the object is enabled
     */
    active?: boolean;
    /**
     * Object creation date
     */
    readonly created_date: string;
    /**
     * Object modification date
     */
    readonly modified_date: string;
    /**
     * Card name, up to 256 characters
     */
    name: string;
    /**
     * Extended description, up to 2048 characters
     */
    comment?: string;
    watch_lists: Array<number>;
    readonly looks_like: CardLooksLike | null;
    meta?: Record<string, any>;
    readonly looks_like_confidence: number;
    license_plate_number?: string | null;
    readonly car_cluster: number;
    /**
     * Linked car objects counter
     */
    readonly car_objects: number;
};
export const EmptyCarCard: CarCard = {
    id: 0,
    /**
     * `true` if the object is enabled
     */
    active: true,
    /**
     * Object creation date
     */
    created_date: '',
    /**
     * Object modification date
     */
    modified_date: '',
    /**
     * Card name, up to 256 characters
     */
    name: '',
    /**
     * Extended description, up to 2048 characters
     */
    comment: '',
    watch_lists: [],
    looks_like: null,
    meta: {},
    looks_like_confidence: 0,
    license_plate_number: '',
    car_cluster: 0,
    /**
     * Linked car objects counter
     */
    car_objects: 0,
};